const lettersUpper = {
  r: 'R',
  y: 'Y',
  w: 'W',
};
export const toUpperCaseFirstLatter = (barcode) => {
  return barcode?.replace(barcode[0], lettersUpper[barcode[0]]);
};
